module.exports = __webpack_public_path__ + "Simple-Line-Icons.0cb0b9c589c0624c9c78.woff2";


//////////////////
// WEBPACK FOOTER
// /var/www/delios/delios-live/app/node_modules/simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module id = ../../../../simple-line-icons/fonts/Simple-Line-Icons.woff2?v=2.4.0
// module chunks = styles